(function () {
  var viewport = document.getElementById('hb-grid-viewport');
  var track = document.getElementById('hb-grid-track');
  var prevBtn = document.getElementById('hb-grid-prev');
  var nextBtn = document.getElementById('hb-grid-next');
  if (!viewport || !track || !prevBtn || !nextBtn) return;

  function getStep() {
    var card = track.querySelector('.hb-product-card');
    if (!card) return viewport.clientWidth;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows() {
    var maxScroll = track.scrollWidth - viewport.clientWidth;
    prevBtn.disabled = viewport.scrollLeft <= 1;
    nextBtn.disabled = viewport.scrollLeft >= maxScroll - 1;
  }

  prevBtn.addEventListener('click', function () {
    viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', function () {
    viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
  });

  viewport.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
})();
